import { DashboardLayout } from '@repo/ui/components/dashboard-layout';
import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { Outlet } from 'react-router-dom';
import { Suspense } from 'react';

export default function InventaireDetailLayout() {
  return (

    <Suspense fallback={<DendromapLoader message="Chargement du détail de l'inventaire..." />}>
      <Outlet />
    </Suspense>

  );
}
